import { render, staticRenderFns } from "./TengXun.vue?vue&type=template&id=37813dc4&scoped=true"
import script from "./TengXun.vue?vue&type=script&lang=js"
export * from "./TengXun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37813dc4",
  null
  
)

export default component.exports